import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely extracts a human-readable string message from an error object or API response.
 * Handles FastAPI Pydantic validation error objects/arrays to prevent React Error #31 rendering crashes.
 */
export function getErrorMessage(error, defaultMsg = 'An unexpected error occurred') {
  if (!error) return defaultMsg;

  const detail = error.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const msgs = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') {
          const msg = item.msg || item.message || JSON.stringify(item);
          return msg.replace(/^Value error,\s*/i, '');
        }
        return String(item);
      })
      .filter(Boolean);
    if (msgs.length > 0) return msgs.join('; ');
  }

  if (detail && typeof detail === 'object') {
    const msg = detail.msg || detail.message;
    if (typeof msg === 'string') return msg.replace(/^Value error,\s*/i, '');
    return JSON.stringify(detail);
  }

  if (typeof error.response?.data?.message === 'string' && error.response.data.message.trim()) {
    return error.response.data.message;
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message;
  }

  return defaultMsg;
}

